// Builds a fallback "initial-letter" avatar as an SVG data URI.
//
// Why a data URI? 
//
// So the value is a real, usable image string (works in any <img src> and can be stored in the DB)
// This lets profile_picture_url stay NOT NULL and frees us from doing a "url || default" ternary.
export function generateInitialAvatar(name) {
    const letter = (name || '?').charAt(0).toUpperCase();

    const svg =
        `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">` +
        `<circle cx="64" cy="64" r="64" fill="#6b7280"/>` +
        `<text x="64" y="64" dy=".35em" text-anchor="middle" fill="#ffffff" ` +
        `font-family="sans-serif" font-size="56" font-weight="600">${letter}</text>` +
        `</svg>`;

    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
